import React ,{useEffect} from 'react';
import AOS from 'aos';
import Banner from '../Components/Pages/What/Banner';
import Container from '../Components/Pages/What/Container';
import Header from '../Components/Shared/Header/Header';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
function What(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header />
        <Banner />
        <Container />
        <Start />
        <Footer />
        </>
    )
};
export default What ;